import React from 'react';

import { Button } from 'components/Buttons/Button';
import { ButtonType } from 'enums/ButtonType';

import styles from './InitialStep.module.scss';

interface StartKbaPageProps {
  onStart: () => void;
  borrowerName?: string | null;
}

const InitialStep = ({ onStart, borrowerName }: StartKbaPageProps) => {
  return (
    <div className={styles.wrapper}>
      <p className={styles.title}>{borrowerName}'s Identity Verification Questions</p>
      <p className={styles.text}>
        To protect your information and prevent fraud, we'll ask a few questions that only you should know the answer
        to.
      </p>
      <p className={styles.text}>This usually takes less than one minute.</p>
      <Button className={styles.button} buttonType={ButtonType.Primary} onClick={onStart}>
        Start
      </Button>
    </div>
  );
};

export default InitialStep;
